export function findLastIndex (array: any[], findFunc: (element: any, index: number) => boolean): number {
  const reversedArray = [...array].reverse();
  const reversedIndex = reversedArray.findIndex(findFunc);

  if (reversedIndex === -1) return -1;

  return (reversedIndex - (array.length - 1)) * -1;
}
